import { useMemo } from 'react'

export default function useFullListGetPageData({ list = [], page = {} }) {
  const pageData = useMemo(() => {
    return {
      result: list.slice(
        (page.pageIndex - 1) * page.pageSize,
        page.pageIndex * page.pageSize
      ),
      recordCount: list.length,
      pageIndex: page.pageIndex,
      pageSize: page.pageSize
    }
  }, [list, page])
  return {
    pageData
  }
}
